import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, SharedFoldersResource, Alert) {
        this.$state = $state;
        this.SharedFoldersResource = SharedFoldersResource;
        this.Alert = Alert;
    }

    $onInit() {
        this.st = new SmartTable();
		this.name="";
    }
	create() {
        this.isSaving = true;
        this.SharedFoldersResource
            .createSharedFolder(this.companyId, this.name)
            .then((data) => {
				// var transformedData=data.toJSON();
                this.sharedFolders.push(data);
                this.$state.go('company.sharing-center.shared-folders.manage.edit', {sharedFolderId: data.id})})
            .finally(() => this.isSaving = false)
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/create/create-shared-folder.controller.js